const mailTemplates = {
	CONSUMPTION: {
		display: 'Meter Readings \u007C Consumption Data',
		description:
			'Recipient: Customer - Informs authorized users that new consumption data has been uploaded with the latest data update',
		preview: '',
	},
	DAMAGE_REPORT: {
		display: 'Damage Report \u007C New',
		preview: 'damagereport',
		description:
			'Recipient: Customer / Property Manager - Contains the information regarding the created damage report',
		info: 'Please note that the fields "Location of Damage" and "Description of Damage" are stored example texts',
	},
	DOCUMENT_USER_DAILY: {
		display: 'Documents \u007C New',
		preview: 'documentusernotifier',
		description: 'Recipient: Customer - Sent when new documents are available',
		info: 'Please note that these are random documents for the user',
	},
	HANDOVER_INVITATION: {
		display: 'Apartment Handover \u007C Appointment Proposal',
		description:
			'Recipient: Customer - Sent to linked users once a new apartment handover with scheduling has been created',
		preview: '',
	},
	LOST_PASSWORD: {
		display: 'Account \u007C Forgot Password',
		description:
			'Recipient: Customer / Property Management - Sent when the "Forgot Password" function is used',
		preview: 'lostpassword',
	},
	MESSAGE: {
		display: 'Message \u007C New',
		description:
			'Recipient: Customer / Property Management - Sent when a new message has been created',
		info: 'Please note that the field "Message" is a stored example text',
		preview: 'message',
	},
	MESSAGE_DONE: {
		display: 'Message \u007C Processed',
		description:
			'Recipient: Customer - Informs the customer that their message has been processed',
		preview: '',
	},
	/*METER_LEVEL: { display: 'Meter Readings \u007C New', preview: '' },*/
	METER_LEVEL_DAILY: {
		display: 'Meter Readings \u007C Not Released',
		description:
			'Recipient: Property Management - Sent when there are meter readings pending approval',
		preview: 'meterleveldaily',
	},
	METER_LEVEL_REJECTED: {
		display: 'Meter Readings \u007C Rejected',
		description:
			'Recipient: Property Management - Sent when a meter reading has been rejected',
		preview: 'meterlevelreject',
	},
	NOTES: {
		display: 'Note \u007C New',
		description:
			'Recipient: Customer - Sent when a new note with notification is created',
		preview: 'note',
	},
	PRIVACY_TOS_REJECTED: {
		display: 'Account \u007C Terms Rejected',
		description:
			'Recipient: Property Management - Informs that a customer has rejected the terms of use or data protection conditions',
		preview: 'privacytosreject',
	},
	SYNC_PROCESSED: {
		display: 'Data Update',
		description:
			'Recipient: Property Management - Contains an overview of the updated data after a data update has been successfully completed',
		preview: '',
	},
	PERSON_DATA_CHANGE_REQUESTED: {
		display: 'Data Change Request \u007C New',
		description:
			'Recipient: Customer - Sent when a new data change request has been created',
		preview: 'personupdaterequest',
		name: 'requested',
	},
	PERSON_DATA_CHANGE_ACCEPTED: {
		display: 'Data Change Request \u007C Accepted',
		description:
			'Recipient: Customer - Sent when a pending data change request is accepted',
		preview: 'personupdaterequest',
		name: 'accepted',
	},
	PERSON_DATA_CHANGE_DECLINED: {
		display: 'Data Change Request \u007C Declined',
		description:
			'Recipient: Customer - Sent when a pending data change request is declined',
		preview: 'personupdaterequest',
		name: 'declined',
	},
	REVIEW_DOCUMENT_STARTED: {
		display: 'Document Review \u007C New',
		description:
			'Recipient: Customer / Reviewer - Sent when a document review has been activated',
		preview: '',
	},
	REVIEW_DOCUMENT_REMINDER: {
		display: 'Document Review \u007C Reminder',
		description:
			'Recipient: Customer / Reviewer - Sent when the reminder function for a document review is activated',
		preview: '',
	},
	REVIEW_DOCUMENT_EXPIRED: {
		display: 'Document Review \u007C Expired',
		description:
			'Recipient: Property Management - Sent when the deadline for a document review has expired',
		preview: '',
	},
	REVIEW_DOCUMENT_ACCEPTED: {
		display: 'Document Review \u007C Accepted',
		description:
			'Recipient: Property Management - Sent when a document review has been accepted',
		preview: '',
	},
	REVIEW_DOCUMENT_DECLINED: {
		display: 'Document Review \u007C Declined',
		description:
			'Recipient: Customer / Reviewer - Sent when a document review has been declined',
		preview: '',
	},
	REVIEW_DOCUMENT_FINISHED: {
		display: 'Document Review \u007C Completed',
		description:
			'Recipient: Customer / Reviewer - Sent when a document review has been completed',
		preview: '',
	},
	REVIEW_DOCUMENT_COMMENTED: {
		display: 'Document Review \u007C Commented',
		description:
			'Recipient: Customer / Reviewer - Sent when a document review has been commented on',
		preview: '',
	},
	REPORT_STARTED: {
		display: 'Report \u007C New',
		description:
			'Recipient: Customer - Informs the recipient that the report has been received by property management',
		preview: '',
	},
	REPORT_STATUS_CHANGED: {
		display: 'Report \u007C Updated',
		description:
			'Recipient: Customer - Informs the recipient about changes in the processing status',
		preview: '',
	},
	REPORT_CRAFTSMAN_TASK_STARTED: {
		display: 'Report \u007C Craftsman Assigned',
		description:
			'Recipient: Customer - Informs the recipient that a craftsman has been assigned',
		preview: '',
	},
	REPORT_STATUS_FINISHED: {
		display: 'Report \u007C Completed',
		description:
			'Recipient: Customer - Informs the recipient that the report has been closed',
		preview: '',
	},
	TICKET_HISTORY: {
		display: 'Ticket \u007C Updates',
		description:
			'Recipient: Customer - Informs the recipient about changes made to a ticket or its related data',
		preview: '',
	},
	WELCOME: {
		display: 'Account \u007C Credentials',
		preview: 'welcome',
		description:
			'Recipient: Customer - Sent when the automatic sending of welcome emails is activated or when a welcome email is sent manually',
	},
}

export default mailTemplates
